<!-- eslint-disable no-unused-vars -->
<script setup>
import { ref, inject, onMounted } from 'vue'
import { useEventStore } from '@/stores/EventStore'
import { timestampsToDateRange } from '@/helpers/datetime'

const siteConfig = inject('siteConfig')

const eventStore = useEventStore()
</script>

<template>
  <section class="storefront-classes">
    <div
      class="hero-banner"
      :style="`background-image: url(/sites/${siteConfig.key}/${siteConfig.assets.banners.events || siteConfig.assets.banners.default})`"
    >
      <div class="container">
        <h1>
          {{ siteConfig.features?.navigation?.titles?.events || 'Events' }}
        </h1>
      </div>
    </div>

    <div class="container">
      <div class="classes-grid">
        <div class="class-type">
          <h4 class="small-bold">Event Collections</h4>
          <ul class="types">
            <li
              @click="eventStore.setFilter('eventGroup', null)"
              :class="{ selected: !eventStore.filters.eventGroup }"
            >
              All Events
            </li>
            <li
              v-for="(group, index) in eventStore.groups"
              :key="index"
              v-html="group"
              @click="eventStore.setFilter('eventGroup', group)"
              :class="{ selected: eventStore.filters.eventGroup?.includes(group) }"
            ></li>
          </ul>
        </div>
        <div class="classes-view">
          <!-- <BaseDropdown :dropdown="classTypes" class="class-type-drop" /> -->

          <div class="classes-wrapper">
            <div
              class="class-box"
              v-for="(event, index) in eventStore.filteredEvents"
              :key="index"
            >
              <div class="class-image">
                <router-link
                  :to="{ name: 'Event Details', params: { eventId: event.id } }"
                >
                  <img :src="event.imageUrl" />
                </router-link>
                <!-- <div class="image-overlay">
                  <h5 class="large-bold" v-html="classBox.category"></h5>
                  <span class="extra-small" v-html="classBox.type"></span>
                </div> -->
              </div>

              <div class="class-info">
                <router-link
                  :to="{ name: 'Event Details', params: { eventId: event.id } }"
                >
                  <h2
                    class="xlarge-text xl:heading-3 mb-2"
                    v-html="event.name"
                  ></h2>
                </router-link>

                <div class="wrapper">
                  <p class="class-schedule">
                    <Icon icon="ci:calendar" class="icon" />
                    <span
                      v-html="
                        event.dateRangeStandard
                      "
                    ></span>
                  </p>
                  <p class="class-schedule">
                    <Icon icon="ci:clock" class="icon" />
                    <span
                      v-html="event.timeLabel"
                    ></span>
                  </p>

                  <div class="class-price">
                    <h3 class="main-price heading-3">
                      {{ event.costSummary }}
                    </h3>
                    <!-- <h4 class="members-price body-bold" v-if="classBox.price.members">
                      &dollar;{{ classBox.price.members.toFixed(2) }}
                      <span class="small-bold">(members)</span>
                    </h4> -->
                  </div>

                  <router-link
                    :to="{
                      name: 'Event Details',
                      params: { eventId: event.id },
                    }"
                    class="btn-accent-1 btn-register xl:large-bold"
                  >
                    Learn more
                  </router-link>
                </div>
              </div>
            </div>
          </div>

          <!-- <BasePagination /> -->
        </div>
      </div>
    </div>
  </section>
</template>

<style scoped>
@import url('./index.pcss');
</style>
